// extracted by mini-css-extract-plugin
export default {"filter-multi-select__filter-name":"filter-multi-select_filter-multi-select__filter-name__FZBHO","filter-multi-select__value":"filter-multi-select_filter-multi-select__value__f6pfd"};